// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-jsx" + "-" + "b4535754500cd06ad4a3" + ".js";
};